import { FunctionComponent, memo } from "react";
import { EllipsisMenu } from "@edgetier/client-components";
import ExemptionForm from "pages/spelling-configuration/spelling-configuration-table/exemption-form";
import EllipsisMenuAction from "components-for/action-menu/ellipsis-menu-action";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { IProps } from "./writing-issues-frequency-table-actions-menu.types";
import "./writing-issues-frequency-table-actions-menu.scss";

/**
 * A dropdown menu to add a spelling exemption
 * @param props.writingIssue
 */
const WritingIssuesFrequencyTableActionsMenu: FunctionComponent<IProps> = ({ writingIssue }) => {
    return (
        <div className="user-actions-menu">
            <EllipsisMenu placement="bottom-end" overflowContainer>
                <EllipsisMenuAction icon={faPlus} modalTitle="Create Exemption" actionLabel="Add exemption">
                    {(closeModal) => <ExemptionForm toggleAction={closeModal} writingIssue={writingIssue} />}
                </EllipsisMenuAction>
            </EllipsisMenu>
        </div>
    );
};

export default memo(WritingIssuesFrequencyTableActionsMenu);
